import { Route } from "react-router-dom";
import CostOfCashPage from "@/pages/CostOfCashPage";
import EposPartnerCalculatorPage from "@/pages/EposPartnerCalculatorPage";
import EcomPartnerCalculatorPage from "@/pages/EcomPartnerCalculatorPage";
import PaymentSolutionFinderPage from "@/pages/PaymentSolutionFinderPage";
import InPersonQuotePage from "@/pages/InPersonQuotePage";
import OnlineQuotePage from "@/pages/OnlineQuotePage";
import OverpayingScorecardPage from "@/pages/OverpayingScorecardPage";
import SwitchVsStayPage from "@/pages/SwitchVsStayPage";
import HiddenFeesCheckerPage from "@/pages/HiddenFeesCheckerPage";
import CashVsCardPage from "@/pages/CashVsCardPage";
import StatementReviewPage from "@/pages/StatementReviewPage";
import SwitchAndSavePage from "@/pages/SwitchAndSavePage";
import ToolsPage from "@/pages/ToolsPage";

export default function ToolRoutes() {
  return (
    <>
      <Route path="/tools" element={<ToolsPage />} />
      <Route path="/switch-and-save" element={<SwitchAndSavePage />} />
      <Route path="/cost-of-cash" element={<CostOfCashPage />} />
      <Route path="/epos-partner-calculator" element={<EposPartnerCalculatorPage />} />
      <Route path="/ecom-partner-calculator" element={<EcomPartnerCalculatorPage />} />
      <Route path="/payment-finder" element={<PaymentSolutionFinderPage />} />
      <Route path="/quote/in-person" element={<InPersonQuotePage />} />
      <Route path="/quote/online" element={<OnlineQuotePage />} />
      <Route path="/overpaying-scorecard" element={<OverpayingScorecardPage />} />
      <Route path="/switch-vs-stay" element={<SwitchVsStayPage />} />
      <Route path="/hidden-fees-checker" element={<HiddenFeesCheckerPage />} />
      <Route path="/cash-vs-card" element={<CashVsCardPage />} />
      <Route path="/statement-review" element={<StatementReviewPage />} />
    </>
  );
}
